import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useFollows } from '../../hooks/useFollows';

const { FiHeart, FiLoader } = FiIcons;

const FollowButton = ({ artistId, userId, className = '' }) => {
  const { isFollowing, followCount, toggling, toggleFollow } = useFollows(userId, artistId);

  if (!userId) return null;

  return (
    <button
      onClick={toggleFollow}
      disabled={toggling}
      className={`flex items-center gap-2 px-5 py-2.5 rounded-2xl border text-xs font-black uppercase tracking-widest transition-all active:scale-95 disabled:opacity-60 ${
        isFollowing
          ? 'bg-brand-pink/15 border-brand-pink/40 text-brand-pink hover:bg-brand-pink/25'
          : 'border-zinc-700 text-zinc-400 hover:border-brand-pink/40 hover:text-brand-pink hover:bg-brand-pink/5'
      } ${className}`}
    >
      {toggling
        ? <SafeIcon icon={FiLoader} className="text-sm animate-spin" />
        : <SafeIcon icon={FiHeart} className={`text-sm ${isFollowing ? 'fill-brand-pink' : ''}`} />
      }
      {isFollowing ? 'Following' : 'Follow'}
      {followCount > 0 && (
        <span className="ml-1 px-1.5 py-0.5 bg-white/5 rounded-lg text-[9px] font-black">
          {followCount.toLocaleString()}
        </span>
      )}
    </button>
  );
};

export default FollowButton;